import React from "react";
import Latex from 'react-latex';

const SafeHTMLContent = ({ html, style = {} }) => {
  // 处理包含 LaTeX 的 HTML
  const renderHTMLWithLatex = (html) => {
    if (!html) return null;
    
    const parts = [];
    let lastIndex = 0;
    
    // 同时匹配行内公式 ($...$) 和块级公式 ($$...$$)
    const regex = /(\$\$[^$]+\$\$|\$[^$]+\$)/g;
    let match;
    
    while ((match = regex.exec(html)) !== null) {
      // 添加前面的普通文本
      if (match.index > lastIndex) {
        parts.push(
          <span key={`text-${lastIndex}`} 
            dangerouslySetInnerHTML={{ __html: html.substring(lastIndex, match.index) }} 
          />
        );
      }
      
      // 判断是行内公式还是块级公式
      const formula = match[0];
      if (formula.startsWith('$$') && formula.endsWith('$$')) {
        // 块级公式
        const latexContent = formula.substring(2, formula.length - 2);
        parts.push(
          <div key={`block-latex-${match.index}`} style={{ textAlign: 'center', margin: '16px 0' }}>
            <Latex displayMode={true}>{`$$${latexContent}$$`}</Latex>
          </div>
        );
      } else {
        // 行内公式
        const latexContent = formula.substring(1, formula.length - 1);
        parts.push(
          <span key={`inline-latex-${match.index}`} style={{ display: 'inline-block', verticalAlign: 'middle' }}>
            <Latex>{`$${latexContent}$`}</Latex>
          </span>
        );
      }
      
      lastIndex = match.index + match[0].length;
    }
    
    // 添加剩余的普通文本
    if (lastIndex < html.length) {
      parts.push(
        <span key={`text-${lastIndex}`} 
          dangerouslySetInnerHTML={{ __html: html.substring(lastIndex) }} 
        />
      );
    }
    
    return parts;
  };

  return (
    <div 
      className="post-content" // 添加这个类名以应用CSS样式
      style={{
        ...style,
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      }}
    >
      {renderHTMLWithLatex(html)}
    </div>
  );
};

export default SafeHTMLContent;